<template>
  <generic-modal :title="$t('factoring')" ref="generic_modal">
    <div v-if="meta.settings">
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.name" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("dpi") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.settings.dpi" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("nit") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.settings.nit" />
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <input
              class="is-checkradio"
              type="checkbox"
              id="chk_execute_sirc"
              name="chk_execute_sirc"
              v-model="meta.settings.execute_sirc"
            />
            <label for="chk_execute_sirc">{{ $t("execute sirc") }}</label>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <input
              class="is-checkradio"
              type="checkbox"
              id="chk_execute_sat"
              name="chk_execute_sat"
              v-model="meta.settings.execute_sat"
            />
            <label for="chk_execute_sat">{{ $t("execute sat") }}</label>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <input
              class="is-checkradio"
              type="checkbox"
              id="chk_execute_wealth_status"
              name="chk_execute_wealth_status"
              v-model="meta.settings.execute_wealth_status"
            />
            <label for="chk_execute_wealth_status">{{
              $t("execute wealth status")
            }}</label>
          </div>
        </div>
      </div>
    </div>
    <div v-if="meta.settings && meta.settings.execute_wealth_status">
      <div class="is-divider"></div>
      <div class="title is-6">{{ $t("wealth status report information") }}</div>
      <div class="subtitle is-6">{{ $t("report date") }}</div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("day") }}</label>
            <div class="control">
              <input
                class="input"
                type="number"
                v-model="meta.settings.wealth_status_day"
                placeholder="0"
                min="0"
                max="31"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("month") }}</label>
            <div class="control">
              <input
                class="input"
                type="number"
                v-model="meta.settings.wealth_status_month"
                placeholder="0"
                min="0"
                max="12"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("year") }}</label>
            <div class="control">
              <input
                class="input"
                type="number"
                v-model="meta.settings.wealth_status_year"
                placeholder="0"
                min="0"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "FactoringModal",
  components: { GenericModal },
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name /* || !v.meta.sale_price */;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    edit_modal(uuid) {
      let v = this;
      v.set_initial_state();

      get("/factoring", { uuid: uuid })
        .then((element) => {
          v.meta = element;
          v.$refs.generic_modal.show_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    save() {
      let v = this;
      if (!v.meta.uuid)
        put("/factoring", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      else
        post("/factoring", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
        settings: {
          execute_sirc: true,
          execute_sat: true,
          execute_wealth_status: true,
        },
      };
      v.error = "";
      // v.uuid = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
